import styled from 'styled-components'

export const Container = styled.div`
  padding-top: ${props => props.theme.whiteLabel.spacing.sp24};
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp24};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`
